import _                           from 'lodash'
import PropTypes                   from 'prop-types'
import React                       from 'react'
import { connect                 } from 'react-redux'
import { withRouter              } from 'react-router'
import { Row, Col, Alert, Button } from 'react-bootstrap'

import { dispatchToProps } from 'alto-utils/lib/store'

import { loadCanteenData, forgetCanteenData, selectDate, selectMeal, deselectMeal, \
         saveCourseGroup, cancelCourseGroup, saveMenu, showOrderSummary, hideOrderSummary } \
  from 'alto-react-canteen/lib/store'
import { menuSetting, GLOBAL, PER_GROUP } from 'alto-react-canteen/lib/settings'

import LoggedOutMenu     from './logged_out_menu'
import DateSelection     from './date_selection'
import DailyMenu         from './daily_menu'
import OrderSummaryModal from './order_summary_modal'

class LoggedInMenu extends LoggedOutMenu.WrappedComponent
  @contextTypes = { auth: PropTypes.object, backend: PropTypes.object, settings: PropTypes.object }

  constructor: (props, context) ->
    super(props, context)

    setting = menuSetting(context.settings)

    @confirmationStyle = setting.confirmation.style

  componentWillMount: ->
    @props.loadCanteenData(@context.backend, @context.settings, true)

  componentWillUnmount: ->

  additionalRenderAbove: ->
    <React.Fragment>
      {@orderConfirmation()}
      {@summary() if @props.orderSummary}
    </React.Fragment>

  orderConfirmation: ->
    if @confirmationStyle == GLOBAL
      saved                   = @props.menu.isSaved()
      additionalMealsSelected = @props.menu.allAdditionalMealsSelected()

      if saved
        caption = 'Všechny Vaše objednávky jsou uloženy'
      else if additionalMealsSelected
        caption = 'Máte neuložené objednávky, kliknutím ZDE přejdete k dokončení objednávky'
      else
        caption = 'Máte neuložené objednávky, nezvolili jste ale všechny povinné přílohy'

      <Row className='order-confirmation'><Col xs={12}>
        {if saved
          <Alert id='menu-saved-alert' bsStyle='success'>{caption}</Alert>
         else
          <Button
           id='save-menu-button'
           bsStyle={if saved then 'success' else 'warning'}
           onClick={=> @props.showOrderSummary()}
           disabled={not additionalMealsSelected}>
            {caption}
          </Button>}
      </Col></Row>
    else
       restIsSaved = @props.menu.otherCanteensAndDatesAreSaved(@props.selectedCanteenID,
                                                               @props.selectedDate)

       unless restIsSaved
         <Row><Col xs={12}><Alert bsStyle='danger'>Máte neuložené objednávky</Alert></Col></Row>

  dailyMenu: (dailyMenu) ->
    <DailyMenu
     menu={dailyMenu}
     selectMeal={@props.selectMeal}
     deselectMeal={@props.deselectMeal}
     confirmationStyle={@confirmationStyle}
     saveCourseGroup={  (group) => @props.saveCourseGroup(  @context.backend, group)}
     cancelCourseGroup={(group) => @props.cancelCourseGroup(@context.backend, group)} />

  summary: ->
    <OrderSummaryModal
     menu={@props.menu}
     error={@props.menuSavingError}
     inProgress={@props.menuIsBeingSaved}
     cancel={       => @props.hideOrderSummary()}
     save={         => @props.saveMenu(@context.backend)}
     logOut={       => @logout()}
     saveAndLogOut={=> @props.saveMenu(@context.backend).then => @logout()} />

  logout: ->
    @props.forgetCanteenData()
    @context.auth.logOut()
    @props.history.push('/')

mapStateToProps    = (state) -> _.pick(state.canteen, 'menu', 'menuIsBeingSaved', 'menuSavingError',
                                       'selectedDate', 'selectedCanteenID', 'orderSummary')
mapDispatchToProps = dispatchToProps({ loadCanteenData, forgetCanteenData,
                                       selectDate, selectMeal, deselectMeal,
                                       saveCourseGroup, cancelCourseGroup, saveMenu,
                                       showOrderSummary, hideOrderSummary })

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoggedInMenu))
